var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wmodal", style: { zIndex: _vm.zIndex } }, [
    _c("div", { staticClass: "wmodal-bgc" }),
    _vm._v(" "),
    _c("div", { staticClass: "wmodal-main" }, [
      _c("div", { staticClass: "wmodal-title" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c("div", { staticClass: "wmodal-content" }, [_vm._t("default")], 2),
      _vm._v(" "),
      _c("div", { staticClass: "wmodal-btnGroup" }, [
        _c(
          "div",
          {
            staticClass: "wmodal-btnGroup-left",
            on: { click: _vm.confirmBtn }
          },
          [_vm._v(_vm._s(_vm.okText))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "wmodal-btnGroup-right",
            on: { click: _vm.cancelBtn }
          },
          [_vm._v(_vm._s(_vm.cancelText))]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d0cd252", { render: render, staticRenderFns: staticRenderFns })
  }
}